import { LoadingDataI, LoadingService2 } from '../services/loading2.service';

export class Loading {
  private static service: LoadingService2;

  static registerService(service: LoadingService2) {
    this.service = service;
  }

  static show(data?: LoadingDataI) {
    if (!this.service) {
      console.error('Loading service not registered!');
      return;
    }
    this.service.toggleLoading({ ...data, show: true });
  }

  static hide() {
    if (!this.service) {
      console.error('Loading service not registered!');
      return;
    }
    this.service.toggleLoading({ show: false });
  }

  static dismiss() {
    if (!this.service) {
      console.error('Loading service not registered!');
      return;
    }
    this.service.toggleLoading({ show: false });
  }
}
